import React, { useState } from 'react';
import FormLayout from '../components/FormLayout';
import VehicleForm from '../components/VehicleForm';
import { afleverFormConfig } from '../config/forms';
import { t } from '../locales/nl';

const AfleverForm: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('');

  return (
    <FormLayout 
      title={t.afleverFormTitle}
      currentSection={currentSection}
    >
      <VehicleForm 
        formType="aflever"
        formConfig={afleverFormConfig}
        onSectionChange={setCurrentSection}
      />
    </FormLayout>
  );
};

export default AfleverForm;